import { BaseLayout } from '~/src/components/shared/layout'
import { CategoryTitle } from '~/src/components/shared'
import { FestivalPosition } from '~/src/generated/graphql'
import { FestivalContextProvider } from '~/src/contexts'
import { FESTIVAL_LINEUP_CATEGORY } from '~/src/const'
import { FestivalNavigation, FestivalBanner, FestivalLineup } from '~/src/components/festival'

export default function LineupPage() {

  return (
    <BaseLayout>
      <FestivalContextProvider>
        <FestivalNavigation />
        <FestivalBanner position={FestivalPosition.Lineup} />
        <CategoryTitle categoryId={FESTIVAL_LINEUP_CATEGORY} />
        <FestivalLineup />
      </FestivalContextProvider>
    </BaseLayout>
  )
}